module.exports = __webpack_public_path__ + "static/about-a24e0a75e91550eec0d92b98e25884e0.png";